<template>
    <div class="container h-full">
        <div class="overflow-hidden rounded-md">
            <div class="px-4 py-5 space-y-6 bg-white">
                <!-- Promocode Reward -->
                <div class="flex items-center justify-between w-full">
                    <div class="block text-lg font-semibold text-gray-700">Discount Amount</div>
                    <div class="flex mt-1 rounded-md shadow-sm">
                        <CounterComponent
                            :current-count="form.reward"
                            @countChanged="countChanged($event, 'reward')"
                        />
                    </div>
                </div>

                <!-- Promocode data -->
                <div class="flex items-center justify-between w-full">
                    <div class="block text-lg font-semibold text-gray-700">Discount Type</div>
                    <div class="flex mt-1 rounded-md shadow-sm w-44">
                        <t-select
                            v-model="form.rewardType"
                            :options="[
                                { text: 'Percentage', value: 'percent' },
                                { text: 'Currency', value: 'currency' },
                            ]"
                            value-attribute="value"
                            text-attribute="text"
                        />
                    </div>
                </div>

                <!-- Promocode data -->
                <div class="flex items-center justify-between w-full">
                    <div class="block text-lg font-semibold text-gray-700">For Product</div>
                    <div class="flex flex-col mt-1 rounded-md shadow-sm w-44">
                        <t-rich-select
                            v-model="form.productId"
                            :clearable="true"
                            :options="productList"
                            value-attribute="id"
                            text-attribute="name"
                        >
                            <template
                                slot="noResults"
                                slot-scope="{ query, className }"
                            >
                                <div :class="className">Sorry no products match "{{ query }}"</div>
                            </template>
                        </t-rich-select>
                    </div>
                </div>

                <!-- Promocode Quantity -->
                <div class="flex items-center justify-between w-full">
                    <div class="block text-lg font-semibold text-gray-700">Times Applicable</div>
                    <div class="flex mt-1 rounded-md shadow-sm">
                        <CounterComponent
                            v-if="!form.isDisposable"
                            :current-count="form.quantity"
                            @countChanged="countChanged($event, 'quantity')"
                        />

                        <div
                            v-else
                            class="flex items-center justify-center h-10 text-lg font-semibold w-44"
                        >
                            1
                        </div>
                    </div>
                </div>

                <!-- Promocode expiresIn -->
                <div class="flex items-center justify-between w-full">
                    <div class="block text-lg font-semibold text-gray-700">Expires In (Days)</div>
                    <div class="flex mt-1 rounded-md shadow-sm">
                        <CounterComponent
                            :current-count="form.expiresIn"
                            @countChanged="countChanged($event, 'expiresIn')"
                        />
                    </div>
                </div>

                <!-- Promocode Disposable -->
                <div class="flex mt-1 rounded-md">
                    <label class="flex items-center">
                        <t-checkbox v-model="form.isDisposable" />
                        <span class="ml-2 text-lg font-medium">Is Disposable</span>
                    </label>
                </div>
            </div>

            <div class="px-4 py-3 text-right">
                <t-button
                    variant="success"
                    :disabled="processing"
                    size="sm"
                    @click="submitForm"
                >
                    {{ processing ? 'Saving...' : 'Save' }}
                </t-button>
            </div>
        </div>
    </div>
</template>

<script>
    import Promocode from '../Models/Promocode';
    import CounterComponent from './CounterComponent.vue';

    export default {
        name: 'CreatePromocode',

        components: {
            CounterComponent,
        },

        data() {
            return {
                form: new Promocode(),
                productList: [],
                processing: false,
            };
        },

        created() {
            this.form.reward = 1;
            this.form.rewardType = 'percent';
            this.form.expiresIn = 1;
            this.form.quantity = 1;
            this.form.productId = 0;
        },

        mounted() {
            this.$axios.get(route('userProducts')).then((res) => {
                this.productList = [{ id: 0, name: 'All products' }, ...res.data.products];
            });
        },

        methods: {
            submitForm() {
                const payload = this.buildPayload();
                this.save(payload);
            },

            buildPayload() {
                const formData = new FormData();
                if (this.form.reward) {
                    formData.append('reward', this.form.reward);
                }
                if (this.form.rewardType) {
                    formData.append('rewardType', this.form.rewardType);
                }
                if (typeof this.form.productId === 'number') {
                    formData.append('productId', this.form.productId);
                }
                if (this.form.quantity) {
                    formData.append('quantity', this.form.quantity);
                }
                if (this.form.expiresIn) {
                    formData.append('expiry', this.form.expiresIn);
                }
                if (this.form.isDisposable) {
                    formData.append('isDisposable', this.form.isDisposable);
                }
                return formData;
            },

            save(payload) {
                this.processing = true;
                this.$inertia.post(route('promocodes.store'), payload, {
                    onSuccess: () => {
                        this.$emit('transactionComplete');
                    },
                    onFinish: () => {
                        this.processing = false;
                    },
                });
            },

            countChanged(newCount, variableName) {
                this.form[variableName] = newCount;
            },
        },
    };
</script>
